<template>
  <span v-if="teamId">
    <figure
      v-if="figureContainer"
      class="is-square"
    >
      <img
        :src="logoPath"
        :alt="alt"
        @error="onError"
      >
    </figure>
    <img
      v-else
      :src="logoPath"
      :alt="alt"
      @error="onError"
    >
  </span>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import * as Sentry from '@sentry/vue';
  import COMMON_UTIL from '@/utils/common.util';
  import {log} from '@/utils/logger';

  const props = withDefaults(defineProps<{
    teamId: string;
    altText?: string;
    figureContainer?: boolean;
  }>(), {
    altText: undefined,
    figureContainer: true,
  });

  // this MUST exist
  const NO_LOGO = 'img/no_logo.png';

  const alt = computed(() => props.altText || props.teamId.toUpperCase());
  const logoPath = computed(() => COMMON_UTIL.paths.clubLogoPath(props.teamId));
  const altPath = computed(() => COMMON_UTIL.paths.clubLogoAltPath(props.teamId));

  function onError(event: Event) {
    // the error event is dispatched on the image that failed to load
    const image = event.target as HTMLImageElement;
    const src = image.src;
    if (src.endsWith(altPath.value)) {
      // fallback to logo-placeholder
      const message = `Logo for teamId=${props.teamId} not found, using fallback-logo '${NO_LOGO}' instead`;
      log.warn(message);
      Sentry.captureMessage(message, 'warning');
      image.src = NO_LOGO;
    } else if (src.endsWith(NO_LOGO)) {
      const message = `The no-logo '${NO_LOGO}' was not found`;
      Sentry.captureMessage(message, 'error');
      log.error(message);
    } else {
      image.src = altPath.value;
    }
  }
</script>
